import { Box, Paper, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

import { IUserEntityModel } from '../../../../../../service/user/IUserEntityModel';
import { ILearningUserDetailModel } from '../../../../../../service/report/interface/ILearningUserDetailModel';
import { Colors } from '../../../../../design/color/Colors';
import { IAnalyticsUserProgressSummary } from '../store/AnalyticsUserDTO';

type IUserProfileCardProperties = {
  user: IUserEntityModel | null;
  userDetail: ILearningUserDetailModel | null;
  progressSummary: IAnalyticsUserProgressSummary;
};

export const UserProfileCard = observer(({ user, userDetail, progressSummary }: IUserProfileCardProperties) => {
  const progressWidth = progressSummary.importantMaxScore
    ? `${(progressSummary.earnedImportantScore * 100) / progressSummary.importantMaxScore}%`
    : '0%';
  const scoreInsideBar = progressSummary.progressPercent >= 30;
  const rolesLabel = userDetail?.roles?.length ? userDetail.roles.join(', ') : undefined;
  const email = userDetail?.email || user?.email;
  const displayName = userDetail?.displayName || user?.displayName || '-';

  return (
    <Paper
      sx={{
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        backgroundColor: Colors.bgElevated,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Typography variant="h5">{displayName}</Typography>
        {rolesLabel ? (
          <Typography variant="body2" color="text.secondary">
            {rolesLabel}
          </Typography>
        ) : null}
        {email ? (
          <Typography variant="body2" color="text.secondary">
            {email}
          </Typography>
        ) : null}
      </Box>

      <Box sx={{ position: 'relative', pt: 4, pb: 3 }}>
        <Box
          sx={{
            height: 44,
            borderRadius: 1,
            backgroundColor: Colors.withOpacity(Colors.primary, 0.2),
            overflow: 'hidden',
            position: 'relative',
          }}
        >
        <Box
          sx={{
            width: progressWidth,
            height: '100%',
            backgroundColor: Colors.primary,
          }}
        />
        <Typography
          component="span"
          sx={{
            fontSize: '24px',
            lineHeight: '24px',
            fontWeight: 700,
            position: 'absolute',
            top: '50%',
            left: scoreInsideBar ? `calc(${progressWidth} / 2)` : `calc(${progressWidth} + 1.5rem)`,
            transform: scoreInsideBar ? 'translate(-50%, -50%)' : 'translate(0, -50%)',
            color: scoreInsideBar ? Colors.textOnPrimary : Colors.textPrimary,
          }}
        >
          {progressSummary.earnedImportantScore}
        </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
          <Typography variant="body1" fontWeight={700}>0</Typography>
          <Typography variant="body1" fontWeight={700}>{progressSummary.importantMaxScore}</Typography>
        </Box>
      </Box>
    </Paper>
  );
});
